import { TextMessageCombinedProps } from './types';

const usePresenter = (props: TextMessageCombinedProps): TextMessageCombinedProps => {
  return props;
};

export default usePresenter;
